import { render, staticRenderFns } from "./service-system.vue?vue&type=template&id=6457df0c&"
import script from "./service-system.js?vue&type=script&lang=js&"
export * from "./service-system.js?vue&type=script&lang=js&"
import style0 from "./service-system.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports